import React from "react";
import MainHeader from "../../mainComponents/Header";
import MainHeaderWithBurger from "../../components/HeaderButton/headerWithBurgerMain";
import MainBitrix24 from "../../mainComponents/Bitrix24";
import Bitrix24Tabs from "./components";
import MainFooter from "mainComponents/MainFooter";

export default function Bitrix24Page() {
    return (
        <div className="bg-[#B0B0B0] min-h-screen  flex flex-col">
            <div className="md:hidden sm:hidden">
                <MainHeader/>
            </div>
            <div className="lg:hidden">
                <MainHeaderWithBurger/>
            </div>
            <div className={"lg:pt-20 lg:pb-40 md:pt-[50px] md:pb-[100px] sm:pt-5 sm:pb-20"}>
                <MainBitrix24/>
            </div>
            <div className={"lg:pb-40 md:pb-[100px] sm:pb-20"}>
                <Bitrix24Tabs/>
            </div>
            <div className={'mb-0 mt-auto'}>
                <MainFooter/>
            </div>
        </div>
    )
}